import { render, staticRenderFns } from "./course-card.vue?vue&type=template&id=588b5220&scoped=true"
import script from "./course-card.vue?vue&type=script&lang=ts"
export * from "./course-card.vue?vue&type=script&lang=ts"
import style0 from "./course-card.vue?vue&type=style&index=0&id=588b5220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b5220",
  null
  
)

export default component.exports